import { render, staticRenderFns } from "./SorteoActualizarNumerosPopup.vue?vue&type=template&id=13b41289&scoped=true&"
import script from "./SorteoActualizarNumerosPopup.vue?vue&type=script&lang=ts&"
export * from "./SorteoActualizarNumerosPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SorteoActualizarNumerosPopup.vue?vue&type=style&index=0&id=13b41289&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b41289",
  null
  
)

export default component.exports